module.exports = __webpack_public_path__ + "static/media/bundle.f0b6dcc4.png";